import { render, staticRenderFns } from "./jgbDetail.vue?vue&type=template&id=267eb6d8&scoped=true"
import script from "./jgbDetail.vue?vue&type=script&lang=js"
export * from "./jgbDetail.vue?vue&type=script&lang=js"
import style0 from "./jgbDetail.vue?vue&type=style&index=0&id=267eb6d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267eb6d8",
  null
  
)

export default component.exports